var getHostname = function () {
    var hostname = window && window.location && window.location.hostname;
    if (!hostname || hostname.length === 0) {
        throw new Error('Hostname could not be determined for the current document.');
    }
    return hostname;
};
var getPathname = function () {
    var pathname = window && window.location && window.location.pathname;
    return pathname;
};
var getDocument = function () {
    var doc = window && window.document;
    if (!doc) {
        throw new Error('DOM document could not be determined.');
    }
    return doc;
};
export default {
    getHostname: getHostname,
    getDocument: getDocument,
    getPathname: getPathname
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYnJvd3Nlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9saWIvYnJvd3Nlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFNLFdBQVcsR0FBaUI7SUFDaEMsSUFBTSxRQUFRLEdBQ1osTUFBTSxJQUFJLE1BQU0sQ0FBQyxRQUFRLElBQUksTUFBTSxDQUFDLFFBQVEsQ0FBQyxRQUFRLENBQUM7SUFFeEQsSUFBSSxDQUFDLFFBQVEsSUFBSSxRQUFRLENBQUMsTUFBTSxLQUFLLENBQUMsRUFBRTtRQUN0QyxNQUFNLElBQUksS0FBSyxDQUNiLDREQUE0RCxDQUM3RCxDQUFDO0tBQ0g7SUFFRCxPQUFPLFFBQVEsQ0FBQztBQUNsQixDQUFDLENBQUM7QUFFRixJQUFNLFdBQVcsR0FBaUI7SUFDaEMsSUFBTSxRQUFRLEdBQ1osTUFBTSxJQUFJLE1BQU0sQ0FBQyxRQUFRLElBQUksTUFBTSxDQUFDLFFBQVEsQ0FBQyxRQUFRLENBQUM7SUFFeEQsT0FBTyxRQUFRLENBQUM7QUFDbEIsQ0FBQyxDQUFDO0FBRUYsSUFBTSxXQUFXLEdBQW1CO0lBQ2xDLElBQU0sR0FBRyxHQUF5QixNQUFNLElBQUksTUFBTSxDQUFDLFFBQVEsQ0FBQztJQUU1RCxJQUFJLENBQUMsR0FBRyxFQUFFO1FBQ1IsTUFBTSxJQUFJLEtBQUssQ0FBQyx1Q0FBdUMsQ0FBQyxDQUFDO0tBQzFEO0lBRUQsT0FBTyxHQUFHLENBQUM7QUFDYixDQUFDLENBQUM7QUFFRixlQUFlO0lBQ2IsV0FBVyxhQUFBO0lBQ1gsV0FBVyxhQUFBO0lBQ1gsV0FBVyxhQUFBO0NBQ1osQ0FBQyJ9